import type { QueryClient } from '@tanstack/react-query';
import { contactKeys, locationKeys } from '@/lib/queryKeys';

/**
 * Forget everything that could name a location.
 *
 * A location is not only created from the Locations screen: typing a service
 * address on a job, an estimate or a proposal saves one to the customer
 * server-side, so a save the client thinks is "just a job" can add a row to
 * lists it is already showing. Nothing in the response says so, which is why
 * the new place only appeared after a reload.
 *
 * Deliberately broad. These are small, cheap lists, and the alternative — every
 * caller guessing which of them a write touched — is how the picker on one
 * screen goes stale while the card on the next is right.
 */
export function invalidateLocationQueries(queryClient: QueryClient, contactId?: string | null) {
  void queryClient.invalidateQueries({ queryKey: locationKeys.all() });
  if (contactId) {
    void queryClient.invalidateQueries({ queryKey: contactKeys.locations(contactId) });
    void queryClient.invalidateQueries({ queryKey: contactKeys.addresses(contactId) });
    void queryClient.invalidateQueries({ queryKey: contactKeys.detail(contactId) });
  }
}
